/* eslint-disable no-unused-vars,@typescript-eslint/no-unused-vars */
import { getPrefixByDes } from '@src/js/separate-logic/utils';

export const externalFnMap = new Map<any, string[]>();

export function external(symbol?: any): Function {
    return function (
        target,
        targetKey: string,
        descriptor: TypedPropertyDescriptor<Function>,
    ): any {
        const prefix = getPrefixByDes(descriptor);
        let array = externalFnMap.get(target);
        if (!array) {
            array = [];
            externalFnMap.set(target, array);
        }
        array.push(prefix + targetKey);
    };
}
